import { AtIcon, IconName } from "../../atoms";
import { MlToastProps, MlToastVariant } from "./ml-toast.types";

export const MlToast = ({ title, variant, onClose }: MlToastProps) => {
  const getToastProps = (): {
    iconName: IconName;
    bgColor: string;
    textColor: string;
  } => {
    switch (variant) {
      case MlToastVariant.SUCCESS:
        return {
          iconName: "check",
          bgColor: "var(--color-success-50)",
          textColor: "text-success-700",
        };
      case MlToastVariant.ERROR:
        return {
          iconName: "error-outline",
          bgColor: "var(--color-error-50)",
          textColor: "text-error-700",
        };
      case MlToastVariant.WARNING:
        return {
          iconName: "warning-amber",
          bgColor: "var(--color-warning-50)",
          textColor: "text-warning-700",
        };
      case MlToastVariant.INFO:
        return {
          iconName: "error-outline",
          bgColor: "var(--color-info-50)",
          textColor: "text-info-700",
        };
    }
  };

  const { iconName, bgColor, textColor } = getToastProps();

  return (
    <div
      className="rounded-sm px-4 py-3 flex justify-between items-center"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex items-center gap-2">
        <AtIcon name={iconName} size={24} className={textColor} />
        <p className={`${textColor} text-xs font-semibold`}>{title}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className={`pl-[10px] cursor-pointer ${textColor}`}
        >
          <AtIcon name="close" size={24} />
        </button>
      )}
    </div>
  );
};
